import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../../app/conf/app.constants';
import { ServiceLocator } from '../../ServiceLocator';
import { FileDetailsDTO } from '../../api/plyca-dtos';
import { generateRandomIdentifier } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';

export class ViewDTOModal {
	public fileItem: FileDetailsDTO;
	constructor(public fileItemParameter: FileDetailsDTO) {

		this.fileItem = fileItemParameter;
	}
}

@Component({
	selector: 'documentFileViewer',
	templateUrl: 'documentFileViewer.template.html'
})
export class documentFileViewerComponent {

	private _fixedDossier = 'Sin Información';
	pdfSrc: any = 'https://vadimdez.github.io/ng2-pdf-viewer/pdf-test.pdf';
	page = 1;
	_configuration: Configuration;
	fileItem: FileDetailsDTO;
	windowHash: string;

	constructor(private route: ActivatedRoute,
		public plycaService: PlycaDataService,
		public ref: DynamicDialogRef,
		public dialogConfig: DynamicDialogConfig,
		private waitService: WaitLoadingService,
		private headerActionsService: HeaderActionsService) {

		this._configuration = ServiceLocator.injector.get(Configuration);


		route.params.subscribe(params => { this._fixedDossier = params['id']; });


		this.fileItem = dialogConfig['item'].fileItem;



	}

	ngAfterContentInit(): void {
		this.windowHash = generateRandomIdentifier();

		this.headerActionsService.addWindowAction(
			'General.close',
			'fas fa-lg fa-times',
			'btn-secondary',
			true, this.windowHash
		).subscribe(success => {
			this.close();
		});

		this.waitService.cancelWaiting();
	}
	close(): void {
		this.ref.close();
	}

	downloadFile(): void {

		console.log('Método downloadFile');
		this.plycaService.downloadEmbedded(this.fileItem).subscribe(
			ok => {
				console.log('Fichero descargado con éxito');
			},
			err => {
				console.log('Error al desbloquera descargar fichero');
				console.log(err);
			}
		);
	}

	isPdf(): boolean {
		return FileDetailsDTO.isPDF(this.fileItem);
	}

}